// Scroll behaviour for in-page anchor links.
//
// scrollIntoView honours scroll-margin-top, so sections that set scroll-mt still
// clear the fixed nav rather than landing underneath it.
export const smoothScrollTo = (el) => {
    const prefersReduced =
        typeof window !== "undefined" &&
        typeof window.matchMedia === "function" &&
        window.matchMedia("(prefers-reduced-motion: reduce)").matches;

    el.scrollIntoView({ behavior: prefersReduced ? "auto" : "smooth", block: "start" });
};

// True when `to` points at a section of the page already being viewed. Only then
// is a smooth scroll right: across a route change the page has just rendered, and
// animating down from the top reads as lag rather than polish.
export const isSamePageAnchor = (to, pathname) => {
    if (typeof to !== "string" || !to.includes("#")) return false;
    const [targetPath] = to.split("#");
    return targetPath === "" || targetPath === pathname;
};
